import React from "react";
import { Box } from "@mui/material";
import { WidgetHeaderChatIcon } from "../widgetPreviewIcons";

function WidgetPreviewHeader({ primaryColor, logo }) {
  return (
    <Box
      sx={{
        height: 200,
        position: "relative",
        overflow: "hidden",
        borderRadius: "8px 8px 0 0",
        background: `linear-gradient(180deg, ${primaryColor} 0%, ${primaryColor}CC 100%)`,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {logo ? (
          <Box
            component="img"
            key={logo}
            src={logo}
            alt=""
            sx={{
              maxWidth: 72,
              maxHeight: 68,
              width: "auto",
              height: "auto",
              objectFit: "contain",
              borderRadius: "50%",
            }}
          />
        ) : (
          <WidgetHeaderChatIcon />
        )}
      </Box>
    </Box>
  );
}

export default React.memo(WidgetPreviewHeader);
